import React, { useState, useEffect } from "react";
import axios from "axios"
import Form from "./components/Form.js";
import Grid from "./components/Grid.js";
import { IoMdArrowRoundBack } from "react-icons/io";


import GlobalStyle from "../../../styles/global.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import fundo from "../../../styles/fundo.svg";
import { IoClose } from "react-icons/io5";

const DivLayout = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;
`;

const Title = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 5.5rem;
  background-image: url(${fundo});
`;

const Title2 = styled.h2`
  width: 100%;
  color: #fff;
  font-size: 28px;
  display: flex;
  justify-content: space-around; 
  align-items: center;

  img{
    height: 50px;
    padding-top: 1.5%;
  }  
`;


const Div = styled.div`
  position: fixed;
  top:0;
  left:0;
  display: flex;
  flex-direction: column;
`;

const Filtro = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;


`;



const ButtonSide1 = styled.button`
  cursor: pointer;
  border: none;
  background-color:transparent;
  color: #fff;
  font-size: 18px;

  &.toggle-btn {
    position: absolute;
    top: 2;
    left: 0;
    padding-left: 1vw;
  }

  &.button-exit{
    position: absolute;
    top: 2;
    right: 0;
    padding-right: 1vw;
  }

`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: start; 
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 80vh; 
  overflow-y: auto; 
`;

const ButtonClose = styled.button`
  position: fixed;
  cursor: pointer;
  border: none;
  background-color: #fff;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.5);
  }
`;


function Usuarios() {

  //------------------------------------------------------------------------------------------//
  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;
  const urlGestao = `${urlFront}gestao/`;


  //---------------------------------------TOKEN---------------------------------------------------//

  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');

  //---------------------------------------VOLTAR A PAGINA INICIAL---------------------------------------------------//

  const handleVoltar = () => {
    window.location.href = urlGestao;
  };

  //---------------------------------------LISTA DE USUÀRIOS---------------------------------------------------//

  const [usuarios, setUsuarios] = useState([]);

  const fetchUsuarios = async () => {
    try {
      const res = await axios.get(`${urlApi}portal/listar-usuarios`, { headers: { Authorization: `Bearer ${token}` } });
      setUsuarios(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de usuarios:', error);
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, [token]);

  //---------------------------------------VERIFICA O VALIDADE DO TOKEN---------------------------------------------------//
  //Verifica o token do usuário
  const [tToken, setToken] = useState("");
  useEffect(() => {
    const getToken = async () => {
      try {
        const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
        setToken(res.data);
      } catch (error) {
        if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
          window.location.href = `${urlFront}login`;
        } else {
          console.error("Erro ao obter token:", error);
        }
      }
    };

    getToken();
  }, [])


  //-----------------------------------------VERIFICA SE O USUARIO PODE ACESSAR O MODULO-------------------------------------------------//
  useEffect(() => {
    const fetchAcessos = async () => {
      try {
        const res = await axios.post(`${urlApi}portal/acessos-portal`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const acessos = res.data;

        // Verifica se o usuário tem acesso ao módulo 0 com tipo A
        const possuiAcessoAoModulo0 = acessos.some(
          (acesso) => acesso.COD_MODULO === 1 && acesso.TIPO_ACESSO === "A"
        );

        if (!possuiAcessoAoModulo0) {
          // Redireciona se não tiver o acesso necessário
          window.location.href = '/login';
        }

      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
        window.location.href = '/login'; // Redireciona também em caso de erro (opcional)
      }
    };

    if (token && id) {
      fetchAcessos();
    }
  }, [token, id]);

  //-------------------------------RECEBE OS PAGINAS CADASTRADAS------------------------------------//

  const [pagina, setPagina] = useState([]);

  const fetchPagina = async () => {
    try {
      const res = await axios.get(`${urlApi}gestao/paginas`, { headers: { Authorization: `Bearer ${token}` } });
      setPagina(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de pagina:', error);
    }
  };

  useEffect(() => {
    fetchPagina();
  }, [token]);


  //-----------------------------------------RECEBE OS MODULOS CADASTRADOS--------------------------//


  const [modulo, setModulo] = useState([]);
  const fetchModulo = async () => {
    try {
      const res = await axios.get(`${urlApi}gestao/modulos`, { headers: { Authorization: `Bearer ${token}` } });
      setModulo(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de modulo:', error);
    }
  };

  useEffect(() => {
    fetchModulo();
  }, [token]);



  //---------------------------------------MODAL EDITAR USUARIO---------------------------------------------------//

  const [editarUsuario, setEditarUsuario] = useState('')

  const [isModalOpenEditarUsuario, setIsModalOpenEditarUsuario] = useState(false);
  const modalEditarUsuario = (item) => {
    setIsModalOpenEditarUsuario(!isModalOpenEditarUsuario);
    setEditarUsuario(item);
  };

  //---------------------------------------PESQUISAR OS ACESSOS DOS USUARIOS---------------------------------------------------//

  const [acesso, setAcessos] = useState([]);

  //Limpa os states quando fecho o modal:
  useEffect(() => {
    if (!isModalOpenEditarUsuario) {
      setEditarUsuario('');
      setAcessos([]);
    }
  }, [isModalOpenEditarUsuario]);



  const fetchAcesso = async () => {
    try {
      const res = await axios.post(`${urlApi}gestao/acessos-usuario`,
        { id: editarUsuario.COD_FUNCIONARIO },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setAcessos(res.data);

    } catch (error) {

    }
  };

  useEffect(() => {


    fetchAcesso();
  }, [editarUsuario]);




  return (
    <>
      <div >

        {isModalOpenEditarUsuario && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <ButtonClose onClick={() => {
                  modalEditarUsuario();

                }}>
                  {isModalOpenEditarUsuario ? <IoClose color={"red"} size={25} /> : <IoClose color={"red"} size={25} />}
                </ButtonClose>
              </ButtonContainer>
              <Form urlApi={urlApi} fetchAcesso={fetchAcesso} pagina={pagina} modulo={modulo} acesso={acesso} editarUsuario={editarUsuario} />
            </ModalContent>
          </ModalContainer>
        )}

        <DivLayout>
          <Title>
            <div>
              <ButtonSide1 className="toggle-btn" onClick={handleVoltar}>
                <IoMdArrowRoundBack size={28} className="gap" />
              </ButtonSide1>
            </div>
            <Title2>
              <div>
                <h2>Usuários</h2>
              </div>
            </Title2>

          </Title>
        </DivLayout>


        <Container>
          <Filtro>

            <Grid usuarios={usuarios} modalEditarUsuario={modalEditarUsuario} />
          </Filtro>

        </Container>
        <Div>

          <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
          <GlobalStyle />
        </Div>
        <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
      </div>
    </>
  );
}

export default Usuarios;
